export default "__VITE_ASSET__Bk$_Gm2N__"